import React, { ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { EnumUserRoute } from '@components-member/userRoutes/enums';
import { keyMap } from '@locales/lokalise/keyMap';

interface IOpenAccountFooterProps {
  agree: boolean;
  translatonKey?: 'tradingAccountsOpenAccountAgree' | 'tradingAccountsOpenAccountAgreeNew';
  changeAgree: () => void;
  children?: ReactNode;
}

const docLink = EnumUserRoute.helpCenterDocumentsPage;

export const OpenAccountFooter = (props: IOpenAccountFooterProps): JSX.Element => {
  const { agree, changeAgree, translatonKey = 'tradingAccountsOpenAccountAgree', children } = props;

  return (
    <div className="main-accounts__agree">
      <div className="form__checkbox">
        <label className="form__checkbox-label-wrapper">
          <input type="checkbox" checked={agree} name="agree" onChange={changeAgree} className="form__checkbox-input" />
          <span className="form__checkbox-label" />
        </label>
        <span className="form__checkbox-label-text">
          <Trans i18nKey={keyMap[translatonKey]}>
            {'I confirm that I have read, understand and agree with the terms and conditions '}
            <a href={docLink} target="_blank" rel="noopener noreferrer">
              Client Agreement
            </a>
            {', '}
            <a href={docLink} target="_blank" rel="noopener noreferrer">
              Risk Disclosure
            </a>
            {', '}
            <a href={docLink} target="_blank" rel="noopener noreferrer">
              Introduction Disclosure
            </a>
            {', '}
            <a href={docLink} target="_blank" rel="noopener noreferrer">
              Liquidity Guideline Agreement
            </a>
            {', '}
            <a href={docLink} target="_blank" rel="noopener noreferrer">
              No Deposit Bonus
            </a>
          </Trans>
        </span>
      </div>
      {children}
    </div>
  );
};
